import { createSlice } from "@reduxjs/toolkit";
import {
  fileManagerReducer,
  getChildFoldersAction,
  renameFolderAction,
  uploadFileInDriveAction,
} from ".";
import { initialState } from ".";
import {
  createFolderAction,
  deleteFileAndFolderAction,
  hideFileFolderAction,
  renameFileAction,
} from "./actions";
import { FileManagerTypes } from "./fileManagerTypes";

export const fileManagerSlice = createSlice({
  name: "fileManager",
  initialState,
  reducers: fileManagerReducer,
  extraReducers: {
    [createFolderAction.pending.toString()]: (state: FileManagerTypes) => ({
      ...state,
      fetching: true,
    }),
    [createFolderAction.fulfilled.toString()]: (
      state: FileManagerTypes,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
      };
    },
    [createFolderAction.rejected.toString()]: (
      state: FileManagerTypes,
      { error }
    ) => ({
      ...state,
      error: error?.message,
      fetching: false,
    }),
    [getChildFoldersAction.pending.toString()]: (state: FileManagerTypes) => ({
      ...state,
      fetching: true,
    }),
    [getChildFoldersAction.fulfilled.toString()]: (
      state: FileManagerTypes,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }
      return {
        ...state,
        fetching: false,
        childFolders: result?.dir_list,
        childFolderCount: result?.dir_count,
        childFiles: result?.file_list,
        childFilesCount: result?.file_count,
        totalCount: result?.total_count,
        currentDirPath: result?.current_dir_path,
        isParrentHide: result?.is_hidden,
        currentFolderDetails: {
          id: result?.id,
          name: result?.name === "root" ? "Home" : result?.name,
          current_dir_path: result?.current_dir_path,
        },
      };
    },
    [getChildFoldersAction.rejected.toString()]: (
      state: FileManagerTypes,
      { error }
    ) => ({
      ...state,
      error: error?.message,
      fetching: false,
    }),
    [uploadFileInDriveAction.pending.toString()]: (
      state: FileManagerTypes
    ) => ({
      ...state,
      uploadFetching: true,
    }),
    [uploadFileInDriveAction.fulfilled.toString()]: (
      state: FileManagerTypes,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          uploadFetching: false,
          error: message,
          statusCode: status_code,
          uploadSuccess: success,
          // uploadFileData:result
        };
      }

      return {
        ...state,
        uploadFetching: false,
        uploadSuccess: success,
        statusCode: status_code,
        uploadFileData: result,
      };
    },
    [uploadFileInDriveAction.rejected.toString()]: (
      state: FileManagerTypes,
      { error }
    ) => ({
      ...state,
      uploadFetching: false,
      uploadSuccess: 0,
      error: error?.message,
    }),
    [renameFolderAction.pending.toString()]: (state: FileManagerTypes) => ({
      ...state,
      fetching: true,
    }),
    [renameFolderAction.fulfilled.toString()]: (
      state: FileManagerTypes,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          success,
          fetching: false,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
      };
    },
    [renameFolderAction.rejected.toString()]: (
      state: FileManagerTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [renameFileAction.pending.toString()]: (state: FileManagerTypes) => ({
      ...state,
      fetching: true,
    }),
    [renameFileAction.fulfilled.toString()]: (
      state: FileManagerTypes,
      { payload }
    ) => {
      const { success, message, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          success,
          fetching: false,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
      };
    },
    [renameFileAction.rejected.toString()]: (
      state: FileManagerTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [deleteFileAndFolderAction.pending.toString()]: (
      state: FileManagerTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [deleteFileAndFolderAction.fulfilled.toString()]: (
      state: FileManagerTypes,
      { payload }
    ) => {
      const { success, message, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          success,
          fetching: false,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
      };
    },
    [deleteFileAndFolderAction.rejected.toString()]: (
      state: FileManagerTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    //
    [hideFileFolderAction.pending.toString()]: (state: FileManagerTypes) => ({
      ...state,
      fetching: true,
    }),
    [hideFileFolderAction.fulfilled.toString()]: (
      state: FileManagerTypes,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          success,
          fetching: false,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
      };
    },
    [hideFileFolderAction.rejected.toString()]: (
      state: FileManagerTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
  },
});

export const {
  resetFileManagerError,
  resetFileManagerSuccess,
  resetFileMangerFetching,
  resetFileManagerStatusCode,
  resetChildFoldersList,
  resetChildFilesList,
  resetCurrentDirPath,
  resetFileManagerUploadSuccess,
  resetUploadFileData,
  resetTotalCount,
} = fileManagerSlice.actions;
